import { useNavigate } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { LeftOutlined } from "@ant-design/icons";

export const BackBtn = ({ wIcon, iconOnly, ...others }) => {
  const navigate = useNavigate();

  return (
    <Tooltip title="Navegar a la página anterior">
      <Button
        icon={wIcon || iconOnly ? <LeftOutlined /> : null}
        onClick={() => navigate(-1)}
        {...others}
      >
        {!iconOnly && "Ir atrás"}
      </Button>
    </Tooltip>
  );
};
